<div *ngIf="!isLoading; else loadingSkeleton">
	<!-- Header -->
	<section class="header">
		<h1 class="text-28-extra-bold text-align-center" dcrHTMLKey="BROWSE_ALL_HEADER_TITLE_{{ mode }}">Select a model</h1>
		<p class="text-14 text-align-center" dcrHTMLKey="BROWSE_ALL_HEADER_DESCRIPTION_{{ mode }}">
			To learn more about a model's holdings and performance, view the "360° Analysis"
		</p>
	</section>

	<!-- Tabs, search bar and table -->
	<section class="grid">
		<mp-models-tabs-container [allFamilies]="allFamilies" [mode]="mode"></mp-models-tabs-container>
	</section>
</div>
<ng-template #loadingSkeleton>
	<mp-models-screener-dialog-skeleton></mp-models-screener-dialog-skeleton>
</ng-template>
